<template>
  <vs-popup title="Proration Preview" :active.sync="popupActivo">
    <div class="p-5" v-if="previewInvoice">
      <!--<pre>{{ JSON.stringify(previewInvoice, null, 2) }}</pre>-->
      <h3>{{ previewInvoice.isUpgrade === true ? 'Upgrade Membership' : 'Downgrade Membership' }}</h3>
      <vs-divider />
      <div>
        <h4>Current Billing Cycle ({{ previewInvoice.currentPlanInterval }})</h4>
        <p class="mt-3">Due {{ previewInvoice.currentPlanEndDate }}</p>
        <div class="mt-6">
          <h4>Current Plan</h4>
          <div class="flex flex-row justify-between">
            <div class="flex flex-row">
              <p class="mt-3">{{ previewInvoice.currentPlanName }}</p>
              <p :class="previewInvoice.currentPlanStatus === 'active' ? 'active-badge p-1 text-center ml-4 mt-2' : 'trailing-badge p-1 text-center ml-4 mt-2'">
                {{ previewInvoice.currentPlanStatus[0].toUpperCase() + previewInvoice.currentPlanStatus.substring(1) }}
              </p>
            </div>
            <p class="mt-3">
              <strong
                >{{ getCurrencySymbol(previewInvoice.currency)
                }}{{ getCurrentPlanPrice(previewInvoice.currentPlanInterval, previewInvoice.currentPlanPrice) / 100 }}/mo</strong
              >
            </p>
          </div>
        </div>
      </div>
      <div class="mt-8 upgrade-plan p-8">
        <h4>{{ previewInvoice.isUpgrade === true ? 'Upgrade Plan' : 'Downgrade Plan' }}</h4>
        <div class="">
          <div class="mt-3 flex flex-row justify-between">
            <p>
              <b>{{ previewInvoice.updatePlanName }}</b>
            </p>
            <p class="">
              <strong>
                {{ getCurrencySymbol(previewInvoice.currency) }}
                {{ getCurrentPlanPrice(previewInvoice.updatePlanInterval, previewInvoice.updatePlanPrice) / 100 }}/mo
              </strong>
            </p>
          </div>
          <p class="disscount px-2 py-2 mt-2" v-if="previewInvoice.isUpgrade && previewInvoice.unUsedTimeAmount">
            {{ getCurrentPlanPrice(previewInvoice.currentPlanInterval, previewInvoice.unUsedTimeAmount).toFixed(2) }}
            {{ getCurrencySymbol(previewInvoice.currency) }}is waived off due to your unused time on plan {{ previewInvoice.currentPlanName }}
          </p>
        </div>
      </div>
      <vs-button
        class="mt-5 w-full upgrade-downgrade-btn"
        @click="
          switchSubscription(
            previewInvoice.isUpgrade,
            previewInvoice.subscriptionId,
            previewInvoice.newPriceId,
            previewInvoice.currentPlanPriceId,
            previewInvoice.country,
            previewInvoice.customer,
            previewInvoice.currentPlanInterval
          )
        "
      >
        {{ previewInvoice.isUpgrade === true ? 'Continue with upgrade' : 'Continue with downgrade' }}
      </vs-button>
      <p class="mt-5">
        Note:
        {{
          previewInvoice.isUpgrade
            ? 'Upgrades are instant, you will be invoiced and charged immediately.'
            : 'Downgrades are scheduled and will be done at the end of the current billing cycle.'
        }}
      </p>
    </div>
  </vs-popup>
</template>

<script>
import axios from 'axios'
import { getStripeForCloudifyUrl } from '@/utils/misc'

export default {
  name: 'ProrationPreview',
  props: ['previewInvoice'],
  data() {
    return {
      popupActivo: false,
    }
  },
  methods: {
    /**
     * @description This function is used to get the currency symboy
     * @param {String} currency this is the currency that user selected
     */
    getCurrencySymbol(currency) {
      const currencySymbolLookup = {
        DKK: 'Kr.',
        USD: '$',
        EUR: '€',
      }
      return currencySymbolLookup[currency]
    },

    /**
     * @description This function is used to get the plan price based on the interval.
     * @param {String} interval this is the interval of the subsciption wether it is monthly or yearly
     * @param {Number} amount this is the amount that we used to show in the preview invoice
     */
    getCurrentPlanPrice(interval, amount) {
      if (interval === 'Yearly') {
        return amount / 12
      } else {
        return amount
      }
    },

    /**
     * @description this function is used to switch the subscription to upgrade or downgrade
     * @param {Boolean} isUpgrade this is used to know wether the user wants to upgrade or downgrade the membership
     * @param {String} stripeSubscriptionId this is used to get the current subscription details
     * @param {String} newPriceId this is used to update the subscription to upgrade or for the downgrade
     */
    async switchSubscription(isUpgrade, stripeSubscriptionId, newPriceId, currentPlanPriceId, country, customer, interval) {
      this.popupActivo = false
      this.$vs.notify({
        title: `${isUpgrade ? 'Upgrading membership' : 'Downgrading Membership'}`,
        text: 'Please Wait . . .',
        color: 'primary',
        time: 10000,
        position: 'top-right',
      })
      const yearly = interval === 'Yearly'
      const switchSubscriptionUrl = `${getStripeForCloudifyUrl()}/stripeSwitchSubscription`
      try {
        await axios.post(switchSubscriptionUrl, {
          isUpgrade,
          newPriceId,
          currentPlanPriceId,
          country,
          customer,
          yearly,
        })
        setTimeout(() => {
          this.$router.go()
        }, 7000)
        this.$rollbar.info(`Subscription Switched from ${currentPlanPriceId} to ${newPriceId}`)
      } catch (error) {
        this.$rollbar.error(`Error While Switching Subscription`, { error })
      }
    },
  },
}
</script>

<style scoped>
.active-badge {
  height: 23px;
  background-color: #dff6de;
  border-radius: 3px;
  color: #70cd7a;
  font-weight: 600;
  font-size: 13px;
}
.trailing-badge {
  background-color: #ff8f0e;
  border-radius: 3px;
  color: #fff;
  font-weight: 600;
  font-size: 13px;
}
.active-badge-1 {
  height: 25px;
  background: #dff6de;
  border-radius: 3px;
  font-size: 12px;
  color: #70cd7a;
  font-weight: 500;
  width: 100%;
}
.upgrade-plan {
  background-color: #a0d4f2;
  border-radius: 5px;
}
.upgrade-downgrade-btn {
  height: 51px;
  color: #ffff;
  font-size: 15px;
  font-weight: 600;
}
.disscount {
  background-color: #bed7e6;
  color: #000000;
  font-size: 14px;
  font-weight: 500;
  border-radius: 3px;
}
</style>
